/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios';
import jwt_decode from "jwt-decode";
import Navbar from "../../Navbar";
import Header from "../../Header";
import baseUrl from "../../BaseUrl";
import Loader from "../../Loader";
import { sansayList } from '../../config';
import { useNavigate, useParams, Link } from 'react-router-dom';
import CreateInputForm from '../comman/CreateInputForm';
import DisplayTable from '../comman/DisplayTable';
import CreateOutboundInputForm from '../comman/CreateOutboundInputForm';
import DisplayOutboundTable from '../comman/DisplayOutboundTable';
import NssTrunkRemovalModal from '../comman/NssTrunkRemovalModal';
import ApiSecretGeneration from "../comman/ApiSecretGeneration";
import CompanyCiaDetail from '../comman/CompanyCiaDetail';
import parseDateWithoutTimezone from "../../UTCDateFormat";
import Select from 'react-select';

const EditUser = () => {
    const { id } = useParams();
    const [name, setName] = useState('');
    // const [company, setCompany] = useState([]);
    const [role, setRole] = useState('');
    const [canUpdateCallPassPermissions, setCanUpdateCallPassPermissions] = useState(false);
    const [token, setToken] = useState('');
    const [expire, setExpire] = useState('');
    const [msg, setMsg] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);
    const [access, setAccess] = useState([]);
    const [carrierTrunk, setCarrierTrunk] = useState([]);
    const [valueList, setValueList] = useState([]);
    const [applicationList, setApplicationList] = useState([]);
    const [outboundTrunkId, setOutboundTrunkId] = useState([]);
    const [outboundValueList, setOutboundValueList] = useState([]);
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [trunkDisabled, setTrunkDisabled] = useState(false);
    const [outBoundTrunkDisabled, setoutBoundTrunkDisabled] = useState(false);
    const [popupOpen, setPopupOpen] = useState(false);
    const [changeDetectSwitch, setChangeDetectSwitch] = useState(true);
    const [changeDetectInput, setChangeDetectInput] = useState(120);
    const [countriesList, setCountriesList] = useState([]);
    const [hasUserTouched, setHasUserTouched] = useState(false);
    const [formData, setFormData] = useState({
        user_role: '0',
        cname: '',
        short_name: "",
        cid: '',
        fname: '',
        lname: '',
        email: '',
        officephone: '',
        mobilephone: '',
        pbx_switch: [],
        pbx_url: {},
        pbx_username: '',
        pbx_password: '',
        timezone: '',
        route_switch: false,
        e911_switch: false,
        cname_switch: false,
        digit_mapping_switch: false,
        advance_digit_mapping_switch: false,
        report_switch: false,
        inventory_switch: false,
        multiple_inventory_switch: false,
        api_enable_switch: false,
        api_access_count: '',
        api_secret: '',
        api_username: '',
        api_daily_switch: false,
        api_enable_switch: false,
        api_daily_access_count: '',
        is_nss_trunk_enable:false,
        update_nss_on_otg_change: false,
        international_order_switch: false,
        call_pass_branded_calling_switch: false,
        enable_call_pass_cdr_email_schedule: false,
        call_pass_display_identities_switch : 0,
        allow_country_list: [],
        allowed_api_access_ips: [],
        allowed_call_pass_cdr_emails: []
    });
    const [accessRight, setAccessRight] = useState({
        createuser: false,
        edituser: false,
        deleteuser: false,
        viewuser: false,
        ordernewnumber: false,
        viewtransactions: false,
        modifynumber: false,
        cancelnumber: false,
        viewinventory: false
    });
    const [setting, setSetting] = useState({
        disconnectSwitch: true,
        disconnectday: 120,
    });
    const [ciaAccessData, setCiaAccessData] = useState({
        cia_id: null,
        cas_type: null,
        switch_action : null,
        cia_enable_switch: false,
        cia_new_number_switch: false,
        cia_new_order_switch: false,
        cia_account_type: '',
        enrms_results_trends:"",
        group_id: '',
        cia_report_type: 1,
        tech_prefix: '',
        speed_level: 1,
        rt_daily_limit: 0,
        rt_monthly_limit: 0,
        rt_group_id: '',
        occurance_type: 1,
        display_date: "",
        format_date: "",
        one_off_time: "",
        schedule_type: 1,
        recurring_type: 1,
        day_of_week: "",
        day_of_month: "",
        every_x_day: "",
        recurring_time: "",
        start_date: "",
        start_date_display: "",
        start_time: ""
    })
    const [trunkData, setTrunksData] = useState([]);
    const [bandwdithDidData, setBandwdithDidData] = useState([]);
    const [bandwdithTollFreeData, setBandwdithTollFreeData] = useState([]);
    const [selectDidAccessData, setSelectDidAccessData] = useState([]);
    const [selectTollFreeAccessData, setSelectTollFreeAccessData] = useState([]);
    const [selectInternationalOrderAccessData, setSelectInternationalOrderAccessData] = useState([]);
    const [trunkAliasInputData, setTrunkAliasInputData] = useState([]);
    const [outboundTrunkData, setOutboundTrunkData] = useState([]);
    const [whiteLabelData, setWhiteLabelData] = useState([]);
    const [trunkId, setTrunkId] = useState([]);
    const [checkedItems, setCheckedItems] = useState([]);
    const [emailInput, setEmailInput] = useState('')
    const [emailError, setEmailError] = useState('');

    // NSS Trunk Removal Modal state
    const [nssTrunkRemovalModal, setNssTrunkRemovalModal] = useState({
        isOpen: false,
        trunkData: null,
        pendingRemovalIndex: null,
        isLoading: false
    });

    const navigate = useNavigate();

    useEffect(() => {
        refreshToken();
    }, []);

    useEffect(() => {
        if (token) {
            //   getUserCompany();
            getUserDetail();
            getUserAccess();
            getCarrierTrunk();
            getApplicationList();
            getCountriesList();
        }
    }, [token]);
    useEffect(() => {
        if (access.length > 0 && token) {
            checkAccess(access, token);
        }

    }, [access, token]);

    // Effect to initialize formData.allow_country_list for displaying tags on initial load
    useEffect(() => {
        // Ensure countriesList is populated, formData.country_list (from DB) exists,
        // and the user hasn't interacted with the dropdown yet.
        if (countriesList && countriesList.length > 0 && formData.country_list && !hasUserTouched) {
            const initialSelectedOptions = optionsToSelectCountry(countriesList, formData.country_list);
            if (initialSelectedOptions) {
                setFormData(prevFormData => ({
                    ...prevFormData,
                    allow_country_list: initialSelectedOptions
                }));
            }
        }
    }, [countriesList, formData.country_list, hasUserTouched]); // Listen to these dependencies

    const refreshToken = async () => {
        try {
            setPopupOpen(true);
            const response = await axios.get(`${baseUrl}/token`);

            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);

            setRole(decoded.role);
            setName(decoded.name);
            setExpire(decoded.exp);
        } catch (error) {

            if (error.response) {
                // setError("Unauthorized");
                navigate("/");
                window.location.reload();
            }
        }
    }

    const getUserAccess = async () => {
        try {
            const response = await axios.get(`${baseUrl}/user-access`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            console.log(response.data.results);
            setAccess(response.data.results);
            setCanUpdateCallPassPermissions(parseInt(response.data.user_call_pass_update_customer_permissions_switch) >= 1);
            // setIsLoading(false);

        } catch (error) {
            console.log(error);
            //    setIsLoading(false);
            // if (error.response) {
            //     // setError("Unauthorized");
            //     navigate("/");  
            //     window.location.reload();
            // }
        }
    }

    const getApplicationList = async () => {
        try {
            const response = await axios.get(`${baseUrl}/get-application-list`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            console.log(response.data.data);
            setApplicationList(response.data.data);
            // setIsLoading(false);

        } catch (error) {
            console.log(error);
        }
    }

    const getCountriesList = async () => {
        try {
            const response = await axios.get(`${baseUrl}/countries`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            // console.log(response.data.list);
            // setCountriesList(response.data.list);
            setCountriesList([{ id: 0, short_name: "Select All" }, ...response.data.list]);

        } catch (error) {
            console.log(error);
        }
    }
    const hasPermission = (permission) => {
        return access.some((item) => item.access === permission);
    };

    const handleSwitchChange = (event) => {
        const { name, checked } = event.target;
        const prevValue = setting[name];
        setSetting((prevSetting) => ({
            ...prevSetting,
            [name]: checked,
        }));
        setChangeDetectSwitch(prevValue);
    };

    const handlePBXSwitchChange = (event) => {

        const { name, checked } = event.target;
        const id = parseInt(name, 10); // Convert the string to a number

        setFormData((prevData) => {
            // If checked, add the numeric ID to the array; if unchecked, remove it
            const updatedPBXSwitch = checked
                ? [...prevData.pbx_switch, id] // Add the number to the array
                : prevData.pbx_switch.filter((item) => item !== id); // Remove the number from the array
            console.log({
                ...prevData,
                pbx_switch: updatedPBXSwitch,
            });
            return {
                ...prevData,
                pbx_switch: updatedPBXSwitch,
            };
        });
    }

    const handleApplicationInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            pbx_url: {
                ...prevFormData.pbx_url,
                [name]: value || '' // Set the value or empty string if value is falsy
            }
        }));
    }

    const handleRouteSwitchChange = (event) => {
        const { name, checked } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: checked,
        }));
    }
    const handleE911SwitchChange = (event) => {
        const { name, checked } = event.target;
        setFormData((prevSetting) => ({
            ...prevSetting,
            [name]: checked,
        }));
    };
    const handleNSSSwitchChange = async (event) => {
        const { name, checked } = event.target;
        if(checked == true){
            if(outboundValueList.length == 0){
                alert("Customer must have outbound trunks defined to enable NSS per trunk.");
                setFormData((prevSetting) => ({
                    ...prevSetting,
                    [name]: false,
                })); 
            }else{
                setFormData((prevSetting) => ({
                    ...prevSetting,
                    [name]: checked,
                })); 
            }
        }else if(checked == false){
            setFormData((prevSetting) => ({
                ...prevSetting,
                [name]: checked,
            }));
        }
    };
    const handleDayChange = (event) => {
        const { name, value } = event.target;
        const prevValue = setting[name];
        setSetting((prevSetting) => ({
            ...prevSetting,
            [name]: value ? parseInt(value) : 0,
        }));
        setChangeDetectInput(prevValue ? parseInt(prevValue) : 0);
    };

    const addToValueList = (value) => {
        console.log(value);
        // setValueList((prevValueList) => [...prevValueList, value]);
        checkTrunks(value);
        setTrunkId(value);
    };

    const addToOutboundValueList = (value) => {
        console.log(value);

        checkOutboundTrunks(value);
        setOutboundTrunkId(value);
    };

    const removeFromValueList = (index) => {
        const newList = valueList.filter((_, i) => i !== index);
        setValueList(newList);
        const data = trunkData.filter((_, i) => i !== index);
        setTrunksData(data);

        const bandwdithdata = bandwdithDidData.filter((_, i) => i !== index);

        setBandwdithDidData(bandwdithdata);

        const bandwdithTollFree = bandwdithTollFreeData.filter((_, i) => i !== index);

        setBandwdithTollFreeData(bandwdithTollFree);

        const didAccessList = selectDidAccessData.filter((_, i) => i !== index);
        setSelectDidAccessData(didAccessList);

        const selectTollFreeAccess = selectTollFreeAccessData.filter((_, i) => i !== index);
        setSelectTollFreeAccessData(selectTollFreeAccess);

        const selectInternationalAccess = selectInternationalOrderAccessData.filter((_, i) => i !== index);
        setSelectInternationalOrderAccessData(selectInternationalAccess);

        const selectTrunkAliasData = trunkAliasInputData.filter((_, i) => i !== index);
        setTrunkAliasInputData(selectTrunkAliasData);
    };

    const removeFromOutboundValueList = (index) => {
        const trunkToRemove = outboundValueList[index];

        // Only show modal if is_nss_trunk_enable AND update_nss_on_otg_change are both enabled
        if (formData.is_nss_trunk_enable && formData.update_nss_on_otg_change) {
            // Directly open modal for NSS confirmation
            setNssTrunkRemovalModal({
                isOpen: true,
                trunkData: {
                    value: trunkToRemove.trunkId,
                    name: trunkToRemove.name,
                    customerName: formData.cname
                },
                pendingRemovalIndex: index,
                isLoading: false
            });
            return; // Wait for modal confirmation
        }

        // Proceed with removal (NSS not enabled)
        performOutboundTrunkRemoval(index);
    };

    const performOutboundTrunkRemoval = (index) => {
        const newList = outboundValueList.filter((_, i) => i !== index);
        setOutboundValueList(newList);

        const data = outboundTrunkData.filter((_, i) => i !== index);
        setOutboundTrunkData(data);
    };

    const handleNssRemovalConfirm = async (trunkData) => {
        setNssTrunkRemovalModal(prev => ({ ...prev, isLoading: true }));

        try {
            await axios.post(`${baseUrl}/confirm-trunk-removal`, {
                customerId: id,
                customerName: formData.cname,
                trunkValue: trunkData.value,
                trunkName: trunkData.name
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            // Remove the trunk from the list
            performOutboundTrunkRemoval(nssTrunkRemovalModal.pendingRemovalIndex);

            // Close modal
            setNssTrunkRemovalModal({
                isOpen: false,
                trunkData: null,
                pendingRemovalIndex: null,
                isLoading: false
            });
        } catch (error) {
            console.error('Error confirming trunk removal:', error);
            alert('Failed to remove numbers from NSS. Please try again.');
            setNssTrunkRemovalModal(prev => ({ ...prev, isLoading: false }));
        }
    };

    const handleNssRemovalExplanation = async (trunkData, explanation) => {
        setNssTrunkRemovalModal(prev => ({ ...prev, isLoading: true }));

        try {
            await axios.post(`${baseUrl}/trunk-removal-explanation`, {
                customerId: id,
                customerName: formData.cname,
                trunkValue: trunkData.value,
                trunkName: trunkData.name,
                userName: name,
                explanation: explanation
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            // Remove the trunk from the list
            performOutboundTrunkRemoval(nssTrunkRemovalModal.pendingRemovalIndex);

            // Close modal
            setNssTrunkRemovalModal({
                isOpen: false,
                trunkData: null,
                pendingRemovalIndex: null,
                isLoading: false
            });
        } catch (error) {
            console.error('Error submitting explanation:', error);
            alert('Failed to submit explanation. Please try again.');
            setNssTrunkRemovalModal(prev => ({ ...prev, isLoading: false }));
        }
    };

    const handleNssRemovalModalClose = () => {
        setNssTrunkRemovalModal({
            isOpen: false,
            trunkData: null,
            pendingRemovalIndex: null,
            isLoading: false
        });
    };

    const checkTrunks = async (trunkList) => {
        try {
            setTrunkDisabled(true);
            setPopupOpen(true);
            const response = await axios.post(`${baseUrl}/get-sansy-data`, { trunkList: trunkList, type: "inbound", company_id: id});
            console.log(response.data.data);
            setTrunkDisabled(false);
            const newData = response.data.data.filter((newValue) => {
                return !valueList.some((existingValue) => existingValue.trunkId == newValue.trunkId);
            });

            // console.log(newData);
            setValueList((prevValueList) => [...prevValueList, ...newData]);
            // setValueList((prevValueList) => [...prevValueList, ...response.data.data]);

            setPopupOpen(false);
        } catch (error) {
            console.log(error);
            setTrunkDisabled(false);
            setPopupOpen(false);
            // if (error.response) {
            //     // setError("Unauthorized");
            //     navigate("/");  
            //     window.location.reload();
            // }
        }
    }

    const checkOutboundTrunks = async (trunkList) => {
        try {
            setoutBoundTrunkDisabled(true);
            setPopupOpen(true);
            const response = await axios.post(`${baseUrl}/get-sansy-data`, { trunkList: trunkList, type: "outbound", company_id: id });
            console.log(response.data);
            setoutBoundTrunkDisabled(false);
            const newData = response.data.data.filter((newValue) => {
                return !outboundValueList.some((existingValue) => existingValue.trunkId === newValue.trunkId);
            });

            setOutboundValueList((prevValueList) => [...prevValueList, ...newData]);

            setPopupOpen(false);

        } catch (error) {
            console.log(error);
            setoutBoundTrunkDisabled(false);
            setPopupOpen(false);
        }
    }

    const handleCheckboxChange = (event, name, type, index) => {
        const isChecked = event.target.checked;

        if (type === 0) {

            setTrunksData((prevTrunkData) => {
                const newTrunkData = [...prevTrunkData];

                newTrunkData[index] = name;

                return newTrunkData;
            });
        } else {
            if (isChecked) {
                setWhiteLabelData([...whiteLabelData, name]);
            } else {
                setWhiteLabelData(whiteLabelData.filter(n => n !== name));
            }
        }

    };

    const handleBandwidthDidCheckboxChange = (event, name, type, index) => {
        const isChecked = event.target.checked;
        if (type === 0) {


            setBandwdithDidData((prevTrunkData) => {
                const newTrunkData = [...prevTrunkData];

                newTrunkData[index] = name;

                return newTrunkData;
            });
        } else {
            if (isChecked) {
                setWhiteLabelData([...whiteLabelData, name]);
            } else {
                setWhiteLabelData(whiteLabelData.filter(n => n !== name));
            }
        }

    };

    const handleBandwidthTollFreeCheckboxChange = (event, name, type, index) => {
        const isChecked = event.target.checked;
        if (type === 0) {


            setBandwdithTollFreeData((prevTrunkData) => {
                const newTrunkData = [...prevTrunkData];

                newTrunkData[index] = name;

                return newTrunkData;
            });
        } else {
            if (isChecked) {
                setWhiteLabelData([...whiteLabelData, name]);
            } else {
                setWhiteLabelData(whiteLabelData.filter(n => n !== name));
            }
        }

    };

    const handleDidAccessCheckboxChange = (event, name, type, index) => {
        const isChecked = event.target.checked;
        if (type === 0) {


            setSelectDidAccessData((prevTrunkData) => {
                const newTrunkData = [...prevTrunkData];

                newTrunkData[index] = name;

                return newTrunkData;
            });
        } else {
            if (isChecked) {
                setWhiteLabelData([...whiteLabelData, name]);
            } else {
                setWhiteLabelData(whiteLabelData.filter(n => n !== name));
            }
        }

    };

    const handleTollFreeAccessCheckboxChange = (event, name, type, index) => {
        const isChecked = event.target.checked;
        if (type === 0) {


            setSelectTollFreeAccessData((prevTrunkData) => {
                const newTrunkData = [...prevTrunkData];

                newTrunkData[index] = name;

                return newTrunkData;
            });
        } else {
            if (isChecked) {
                setWhiteLabelData([...whiteLabelData, name]);
            } else {
                setWhiteLabelData(whiteLabelData.filter(n => n !== name));
            }
        }
    };

    const handleInternationalOrderAccessCheckboxChange = (event, name, type, index) => {
        const isChecked = event.target.checked;
        if (type === 0) {


            setSelectInternationalOrderAccessData((prevTrunkData) => {
                const newTrunkData = [...prevTrunkData];

                newTrunkData[index] = name;

                return newTrunkData;
            });
        } else {
            if (isChecked) {
                setWhiteLabelData([...whiteLabelData, name]);
            } else {
                setWhiteLabelData(whiteLabelData.filter(n => n !== name));
            }
        }

    };
    
    const handleTrunkAliasInputChange = (event, name, type, index) => {
        const isChecked = event.target.value;
        if (type === 0) {


            setTrunkAliasInputData((prevTrunkData) => {
                const newTrunkData = [...prevTrunkData];
                console.log(name, "name");
                newTrunkData[index] = name;

                return newTrunkData;
            });
        } else {
            if (isChecked) {
                setWhiteLabelData([...whiteLabelData, name]);
            } else {
                setWhiteLabelData(whiteLabelData.filter(n => n !== name));
            }
        }

    };

    const handleOutboundCheckboxChange = (event, name, type, index) => {
        console.log(index);
        const isChecked = event.target.checked;


        if (type === 0) {


            setOutboundTrunkData((prevTrunkData) => {
                const newTrunkData = [...prevTrunkData];

                newTrunkData[index] = name;

                return newTrunkData;
            });
        } else {
            // if (isChecked) {
            //     setWhiteLabelData([...whiteLabelData, name]);
            // } else {
            //     setWhiteLabelData(whiteLabelData.filter(n => n !== name));
            // }
        }


    };
    useEffect(() => {
        console.log(outboundTrunkData);
    }, [outboundTrunkData])


    const checkAccess = async (access) => {
        if ((role !== 2 && role !== 1 && role !== 0) || (role === 2 && !hasPermission('edituser'))) {
            navigate('/dashboard');
        }

    }



    const getUserDetail = async () => {
        setPopupOpen(true);
        const response = await axios.get(`${baseUrl}/user-company/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        setPopupOpen(false);
        // console.log(userData.pbx_password);
        const userData = response.data.user[0];
        // console.log(userData);
        setFormData({
            // user_role: userData.role, // Convert to string if needed
            cname: userData.cname,
            short_name: userData.short_name,
            cid: userData.cid,
            fname: userData.fname,
            lname: userData.lname,
            email: userData.email,
            officephone: userData.office_phone,
            mobilephone: userData.mobile_phone,
            pbx_switch: JSON.parse(userData.pbx_switch) ?? [],
            pbx_url: userData.pbx_url ?? {},
            pbx_username: userData.pbx_username,
            pbx_password: userData.pbx_password,
            timezone: userData.timezone,
            route_switch: userData.route_switch === 1,
            e911_switch: userData.e911_switch === 1,
            digit_mapping_switch: userData.digit_mapping_switch === 1,
            advance_digit_mapping_switch : userData.advance_digit_mapping_switch === 1,
            cname_switch: userData.cname_switch === 1,
            report_switch: userData.report_switch === 1,
            inventory_switch: userData.inventory_switch === 1,
            multiple_inventory_switch: userData.multiple_inventory_switch === 1,
            api_enable_switch: userData.api_enable_switch === 1,
            api_access_count: userData.api_access_count,
            api_secret: userData.api_secret,
            api_username: userData.api_username,
            api_daily_switch: userData.api_daily_switch === 1,
            api_enable_switch: userData.api_enable_switch === 1,
            api_daily_access_count: userData.api_daily_access_count ?? 0,
            capi_daily_usage_switch: userData.capi_daily_usage_switch === 1,
            capi_daily_usage_count: userData.capi_daily_usage_count ?? 0,
            capi_monthly_number_order_count: userData.capi_monthly_number_order_count ?? 0,
            enable_bap_api: userData.enable_bap_api === 1,
            enable_tns_api: userData.enable_tns_api === 1,
            enable_call_pass_api: userData.enable_call_pass_api === 1,
            enable_enrms_api: userData.enable_enrms_api === 1,
            allowed_api_access_ips: userData.allowed_api_access_ips ? userData.allowed_api_access_ips.split(',') : [],
            is_nss_trunk_enable: userData.is_nss_trunk_enable === 1,
            update_nss_on_otg_change: userData.update_nss_on_otg_change === 1,
            international_order_switch : userData.international_order_switch === 1,
            country_list:  userData.allow_country_list,
            call_pass_branded_calling_switch : userData.call_pass_branded_calling_switch === 1,
            enable_call_pass_cdr_email_schedule: userData.enable_call_pass_cdr_email_schedule === 1,
            allowed_call_pass_cdr_emails: userData.allowed_call_pass_cdr_emails ? userData.allowed_call_pass_cdr_emails.split(',') : [],
            call_pass_display_identities_switch : parseInt(userData.call_pass_display_identities_switch) || 0,
            // cia_id : userData?.cia_id,
            // cia_enable_switch : userData.cia_enable_switch,
            // cia_account_type: userData.cia_account_type === 1 ? 'Customer-CASD' : userData.cia_account_type === 0 ? 'BBD-CASD' : '',
            // cia_schedule_type : userData.cia_schedule_type === 1 ? 'manual_selection' : userData.cia_schedule_type === 0 ?'regular_default_schedule' : '',
            // cia_schedule_hours : userData?.cia_schedule_hours,
            // cia_schedule_days: userData?.cia_schedule_days 
        });
        const userAccessData = response.data.user_access;

        const updatedAccessRight = { ...accessRight }; // Create a copy of the state

        userAccessData.forEach((access) => {
            const { access: accessName, value } = access;
            updatedAccessRight[accessName] = value === 1; // Convert value to boolean
        });

        setCiaAccessData({
            cia_id: userData?.cia_id,
            cas_type: userData.cas_type === 1 ? true : false,
            switch_action : null,
            cia_enable_switch: userData.cia_enable_switch === 1 ? true : false,
            cia_new_number_switch: userData.cia_new_number_switch === 1 ? true : false,
            cia_new_order_switch: userData.cia_new_order_switch === 1 ? true : false,
            cia_account_type: userData.cia_account_type,
            enrms_results_trends: userData.enrms_results_trends === 1 ? true : false,
            group_id: userData.group_id,
            cia_report_type: userData.cia_report_type ?? 1,
            tech_prefix: userData.tech_prefix ?? null,
            speed_level: userData.speed_level || 1,
            rt_daily_limit: userData.rt_daily_limit ?? 0,
            rt_monthly_limit: userData.rt_monthly_limit ?? 0,
            rt_group_id: userData.rt_group_id ?? '',
            occurance_type: userData?.occurance_type ?? 1,
            display_date: userData?.format_date ? parseDateWithoutTimezone(userData?.format_date) : null,
            format_date: userData?.format_date ?? null,
            one_off_time: userData?.one_off_time ?? null,
            recurring_type: userData?.recurring_type ?? 1,
            day_of_week: userData?.day_of_week ?? null,
            day_of_month: userData?.day_of_month ?? null,
            every_x_day: userData?.every_x_day ?? null,
            recurring_time: userData?.recurring_time ?? null,
            start_date: userData?.start_date ?? null,
            start_date_display: userData?.start_date ? parseDateWithoutTimezone(userData?.start_date) : null,
            start_time: userData?.start_time ?? null
            
        })

        setAccessRight(updatedAccessRight);

        const userSettingData = response.data.user_setting[0];

        if (userSettingData) {
            setSetting({
                disconnectSwitch: userSettingData.disconnect_switch === 1,
                disconnectday: userSettingData.disconnect_day,
            });
            setChangeDetectSwitch(userSettingData.disconnect_switch === 1);
            setChangeDetectInput(userSettingData.disconnect_day);
        }
        // console.log(setting.disconnectSwitch);

        const userTrunk = response.data.user_trunk;
        console.log(userTrunk);
        setTrunksData(userTrunk);
        const userLabel = response.data.user_white_label;
        const userBandwidthDid = response.data.user_bandwidth_did;
        const userBandwidthTollFree = response.data.user_bandwidth_toll_free;
        setBandwdithDidData(userBandwidthDid);
        setBandwdithTollFreeData(userBandwidthTollFree);
        const userDidAccess = response.data.user_did_access;
        const userTollFreeAccess = response.data.user_toll_free_access;
        const userInternationalOrderAccess = response.data.user_international_order_access;
        const userTrunkAliasAccess = response.data.user_trunk_alias;
        setSelectDidAccessData(userDidAccess);
        setSelectTollFreeAccessData(userTollFreeAccess);
        setSelectInternationalOrderAccessData(userInternationalOrderAccess ?? []);
        setTrunkAliasInputData(userTrunkAliasAccess ?? []);

        const outboundData = response.data.user_outbound;
        const outboundTrunkData = response.data.user_outbound_trunk;
        //   console.log(outboundData);
        setWhiteLabelData(userLabel);
        setValueList(userLabel);
        setOutboundTrunkData(outboundTrunkData);
        setOutboundValueList(outboundData);
        setCheckedItems(JSON.parse(userData.sansay_priority) ?? []);
        // console.log(userData);
    };
    const [validationErrors, setValidationErrors] = useState({
        user_role: false,
        email: false,
        cname: false,
        short_name: false,
        fname: false,
        lname: false,
        officephone: false,
        mobilephone: false,
        timezone: false
        // tid:false

    });
    const formRef = useRef(null);
    const validateEmail = (email) => {
        // Implement your email validation logic here
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        const newValidationErrors = {
            user_role: formData.user_role === '0',
            email: !validateEmail(formData.email),
            cname: formData.cname === '' || /,/.test(formData.cname),
            short_name: formData.short_name == '' || formData.short_name == null || formData.short_name.length > 26,
            fname: formData.fname === '',
            lname: formData.lname === '',
            officephone: !/^\d{1,10}$/.test(formData.officephone),
            mobilephone: !/^\d{1,10}$/.test(formData.mobilephone),
            timezone: formData.lname === ''
            // tid: valueList.some(item => item.isValid === false)


        };
        setValidationErrors(newValidationErrors);

        // Check if there are any validation errors
        const hasErrors = Object.values(newValidationErrors).some((error) => error);

        if (hasErrors) {

            // Find the first invalid input element
            const firstInvalidInput = formRef.current.querySelector('.invalid');
            console.log(firstInvalidInput);
            if (firstInvalidInput) {
                // Scroll to the first invalid input element
                firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        } else {

            let checkOption = true;
            if (setting.disconnectSwitch != changeDetectSwitch || setting.disconnectday != changeDetectInput) {
                const userConfirmed = window.confirm("Are you sure you want to change the minimum disconnect option?");
                if (userConfirmed) {
                    checkOption = true;
                } else {
                    checkOption = false;
                }
            }
            if (ciaAccessData.recurring_type == 2 && (ciaAccessData.day_of_week == null || ciaAccessData.day_of_week == '' || ciaAccessData.day_of_week == 0)) {
                alert("Please select a day of week in CAS enabled number");
                return
            };
            if (ciaAccessData.recurring_type == 3 && (ciaAccessData.day_of_month == null || ciaAccessData.day_of_month == '' || ciaAccessData.day_of_month == 0)) {
                alert("Please select a day of month in CAS enabled number");
                return
            };
            if (ciaAccessData.recurring_type == 4 && (ciaAccessData.every_x_day == null || ciaAccessData.every_x_day == '' || ciaAccessData.every_x_day == 0)) {
                alert("Please enter valid value in CAS enabled number");
                return
            };
            if (checkOption) {

                const rightsArray = Object.entries(accessRight).map(([key, value]) => ({
                    name: key,
                    value: value ? 1 : 0,
                }));

                const combinedData = {
                    formData: { 
                        ...formData, 
                        allowed_api_access_ips: formData.allowed_api_access_ips.length > 0 ? formData.allowed_api_access_ips.join(',') : '',
                        allowed_call_pass_cdr_emails: formData.allowed_call_pass_cdr_emails.length > 0 ? formData.allowed_call_pass_cdr_emails.join(',') : '',
                    },
                    ciaAccessData: ciaAccessData,
                    rightsArray: rightsArray,
                    setting: setting,
                    trunks: trunkData,
                    whitelabel: whiteLabelData,
                    newTid: valueList.filter(value => value.isValid),
                    outboundTid: outboundValueList.filter(value => value.isValid),
                    outboundTrunkData: outboundTrunkData,
                    bandwdithDidData: bandwdithDidData,
                    bandwdithTollFreeData: bandwdithTollFreeData,
                    selectDidAccessData: selectDidAccessData,
                    selectTollFreeAccessData: selectTollFreeAccessData,
                    selectInternationalOrderAccessData:selectInternationalOrderAccessData,
                    trunkAliasInputData:trunkAliasInputData,
                    sansayPriority: checkedItems
                };
                console.log(combinedData);
                try {
                    setButtonDisabled(true);
                    setPopupOpen(true);
                    await axios.post(`${baseUrl}/user-company/${id}`, combinedData, {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    });
                    setIsSuccess(true);
                    navigate("/user-company/list");
                } catch (error) {
                    setButtonDisabled(false);
                    setPopupOpen(false);
                    if (error.response) {
                        setIsSuccess(false);
                        setMsg(error.response.data.msg);
                    }
                }
            }
        }
    }
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'user_role' && value <= 2) {
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
                cname: '1', // Set cname to '1' if user_role is less than or equal to 2
                short_name: '1'
            }));
            setTrunksData([]);
            setWhiteLabelData([]);
        } else {
            setFormData((prevData) => ({
                ...prevData,
                [name]: value
            }));
        }

        setValidationErrors((prevErrors) => ({
            ...prevErrors,
            [name]: false
        }));
    };

    const accessRightLabels = {
        createuser: 'Create Users/Customers',
        edituser: 'Edit Users/Customers',
        deleteuser: 'Delete Users/Customers',
        viewuser: 'View Users/Customers',
        ordernewnumber: 'Order New Number Access',
        modifynumber: 'Modify Number',
        cancelnumber: 'Cancel Number',
        viewinventory: 'View Inventory'
    };


    // const handleTrunkInputChange = (e, name) => {
    //     const newValue = e.target.value;
    //     console.log(newValue);
    //     console.log(name);
    //     // Update trunkData if 'BBD_DID_LA1_1900' is in trunkData
    //     if (trunkData.some(item => item.name === name)) {
    //         setTrunksData(trunkData.map(item => 
    //         item.name === name ? { ...item, value: newValue } : item
    //       ));
    //     }

    // };
    const handleTrunkInputChange = (e, name, index) => {
        const newValue = e.target.value;


        // Update trunkData at the specified index
        if (index !== undefined && trunkData[index]?.name === name) {
            const updatedTrunkData = [...trunkData];
            updatedTrunkData[index] = { ...updatedTrunkData[index], value: newValue };
            setTrunksData(updatedTrunkData);
        }
    };

    const handleOutboundTrunkInputChange = (e, name, index) => {
        const newValue = e.target.value;
        // console.log(newValue);
        console.log(e.target.value);


        if (index !== undefined && outboundTrunkData[index]?.name === name) {
            const updatedTrunkData = [...outboundTrunkData];
            updatedTrunkData[index] = { ...updatedTrunkData[index], value: newValue };
            setOutboundTrunkData(updatedTrunkData);
        }
    };

    const getCarrierTrunk = async () => {
        try {
            setPopupOpen(true);
            const response = await axios.get(`${baseUrl}/carrier-trunk`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setPopupOpen(false);
            // console.log(response.data);
            setCarrierTrunk(response.data.data);
            // setIsLoading(false);

        } catch (error) {
            console.log(error);
            setPopupOpen(false);
            //    setIsLoading(false);
            // if (error.response) {
            //     // setError("Unauthorized");
            //     navigate("/");  
            //     window.location.reload();
            // }
        }
    }

    const timeZones = [
        { value: "EST", label: "Eastern Standard Time" },
        { value: "CST", label: "Central Standard Time" },
        { value: "MST", label: "Mountain Standard Time" },
        { value: "PST", label: "Pacific Standard Time" },
        { value: "AKST", label: "Alaska Standard Time" },
        { value: "HAST", label: "Hawaii-Aleutian Standard Time" },
        { value: "AST", label: "Atlantic Standard Time" },
        { value: "ChST", label: "Chamorro Standard Time" }
    ];

    // Sort the time zones alphabetically by label
    timeZones.sort((a, b) => a.label.localeCompare(b.label));



    const handleSansayPriorityCheckbox = (itemName, isChecked) => {
        if (isChecked) {
            setCheckedItems(prevCheckedItems => [...prevCheckedItems, itemName]);
        } else {
            setCheckedItems(prevCheckedItems => prevCheckedItems.filter(item => item !== itemName));
        }
    };

    // const handleApiKeySecret = ( apiSecret) => {
    //     setFormData((prevData) => ({
    //         ...prevData,
    //         ["api_secret"]: apiSecret
    //     }));

    // }

    // useEffect(()=>{
    //     console.log('CiaAccessData',ciaAccessData)
    // },[ciaAccessData])

    const updateCiaAccessData = (update) => {
        setCiaAccessData(update)
    }

    const updatedTNSDetail = (updatedData) => {
        setFormData((prevData) => ({
            ...prevData,
            api_access_count: updatedData.api_access_count,
            api_daily_access_count: updatedData.api_daily_access_count,
            api_daily_switch: updatedData.api_daily_switch,
            api_enable_switch:updatedData.api_enable_switch,
            capi_daily_usage_switch:updatedData.capi_daily_usage_switch,
            capi_daily_usage_count:updatedData.capi_daily_usage_count,
            capi_monthly_number_order_count:updatedData.capi_monthly_number_order_count,
            enable_bap_api:updatedData.enable_bap_api,
            enable_tns_api:updatedData.enable_tns_api,
            enable_call_pass_api: updatedData.enable_call_pass_api,
            enable_enrms_api: updatedData.enable_enrms_api,
            allowed_api_access_ips: updatedData.allowed_api_access_ips
        }));
    }

    const optionsToShowCountry = formData.allow_country_list?.some(opt => opt.value == 0)
    ? [] // hide everything if "Select All" is selected
    : countriesList?.map(item => {
        return {
            value: item.id,
            label: item.id === 0 ? item.short_name : `${item.short_name} - ${item.name}` // Assuming 'item.name' holds the full country name
        };
    });

    const optionsToSelectCountry = (countriesList, selectedId) => {
        const dbValue = selectedId ?? "";  // default to empty string if null/undefined

        // If countriesList isn't loaded yet, wait
        if (!countriesList || countriesList.length === 0) return;
    
        // Only map if dbValue has something
        const selectedOptions = dbValue
            ? dbValue.split(',').map(Number).map(id => {
                const found = countriesList.find(item => item.id === id);
                return found ? { value: found.id, label: found.id === 0 ? found.short_name : `${found.short_name} - ${found.name}` } : null; // Assuming 'found.name' holds the full country name
            }).filter(Boolean)
            : [];
        return selectedOptions;
    }
    

    const handleCountryChange = (selectedOptions) => {
        setHasUserTouched(true);
        // Check if "Select All" was selected
    const isSelectAll = selectedOptions?.some(option => option.value === 0);

    if (isSelectAll) {
        // If "Select All" is selected, set only that option
        setFormData({
            ...formData,
            allow_country_list: [{ value: 0, label: "Select All" }]
        });
    } else {
        setFormData({
            ...formData,
            allow_country_list: selectedOptions
        });
    }
    };

    // Custom MultiValue component to hide selected items inside the Select input
    const CustomMultiValue = () => {
        return null; // Render nothing inside the input
    };

    // Function to handle removing a country from the selected list
    const handleRemoveCountry = (countryValueToRemove) => {
        setHasUserTouched(true); // Removing is also a user touch
        const updatedSelectedOptions = formData.allow_country_list.filter(
            option => option.value !== countryValueToRemove
        );
        setFormData({ ...formData, allow_country_list: updatedSelectedOptions });
    };

    const handleAddEmail = async (e) => {
        // prevent default submit if button is inside a form
        if (e && e.preventDefault) e.preventDefault();
        const email = (emailInput || '').trim().toLowerCase();

        // Validate format
        if (!validateEmail(email)) {
            setEmailError('Please enter a valid email address.');
            return;
        }

        // Prevent duplicate (case-insensitive)
        const exists = formData.allowed_call_pass_cdr_emails?.some(item => item.toLowerCase() === email);
        if (exists) {
            setEmailError('This email is already added.');
            return;
        }

        // Validate that email has Call Pass access for this company
        try {
            const response = await axios.post(`${baseUrl}/validate-call-pass-cdr-email`, {
                email,
                cid: id
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (!response.data.isValid) {
                setEmailError(response.data.msg || 'This email does not have Call Pass access for this customer.');
                return;
            }
        } catch (error) {
            setEmailError('Failed to validate email. Please try again.');
            return;
        }

        // Add email
        setFormData((prevFormData) => {
            const updatedEmails = [...(prevFormData.allowed_call_pass_cdr_emails || []), email];
            return {
                ...prevFormData,
                allowed_call_pass_cdr_emails: updatedEmails,
            };
        });

        setEmailInput('');
        setEmailError('');
    }

    const handleRemoveEmail = async (email) => {
        setFormData((prevFormData) => {
            let updatedFormData = { ...prevFormData };
                updatedFormData = {
                    ...prevFormData,
                    allowed_call_pass_cdr_emails: updatedFormData.allowed_call_pass_cdr_emails.filter(item => item !== email),
                };
            return updatedFormData;
        });
    }

    return (
        <div className="panelbox">
            <Navbar token={token} access={access} />
            <div className="right-panel">
                <Header name={name} />
                {popupOpen && (
                    <Loader />
                )}
                <div className="content-page admin-new-addstaff-page">
                    <div className="fullrow">
                        <div className="row">
                            <div className="col-6">
                                <div className="left-title">
                                    <h1>Edit Customer</h1>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="addnew-button">
                                    <Link to="/user-company/list"><span>&larr;</span> Back</Link>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <p className={`has-text-centered ${isSuccess ? 'success' : 'error'}`}>{msg}</p>
                                <div className="edit-staff-data-form add-new-staff-form">
                                    <form className="form-box" onSubmit={handleSubmit} ref={formRef}>
                                        <div className="common-white-shadow-background">
                                            <div className="innerboxwidth">
                                                <div className="row">
                                                    <div className="col-12">
                                                        <h3>User Info</h3>
                                                    </div>
                                                    {/* <div className="col-6">
                                                        <select name="user_role" id="user_role"  value={formData.user_role} onChange={handleInputChange} className={validationErrors.user_role ? 'invalid' : ''}>
                                                            <option value="0">User Types</option>                
                                                            {role === 0 && <option value="1">Super Admin</option>}
                                                            {role <= 1 && <option value="2">Support User</option>}
                                                            {role <= 2 && <option value="3">Reseller admin user</option>}
                                                            {role <= 3 && <option value="4">Customer admin user</option>}
                                                            {role <= 4 && <option value="5">Customer user</option>}
                                                        </select>
                                                        {validationErrors.user_role && <div className="error-message">Please select a user role.</div>}
                                                    </div> */}
                                                    <div className="col-md-12">
                                                        {/* <select name="cname" value={formData.cname} onChange={handleInputChange} className={validationErrors.cname ? 'invalid' : ''} >
                                                            <option value="">Select a company</option>
                                                            {company.map((comp, index) => (
                                                              <option key={index} value={comp.id}>
                                                                {comp.cname}
                                                              </option>
                                                            ))}
                                                        </select> */}
                                                        <label>Company Name</label>
                                                        <input type="text" name="cname" defaultValue={formData.cname}
                                                            placeholder="Company Name*" disabled={formData.user_role >= 2} onChange={handleInputChange} className={validationErrors.cname ? 'invalid' : ''} />
                                                        {validationErrors.cname && <div className="error error-message">Please enter company name without comma.</div>}
                                                    </div>
                                                    <div className="col-md-12">
                                                        <label>Short Company Name</label>
                                                        <input type="text" name="short_name" defaultValue={formData.short_name}
                                                            placeholder="Short Company Name*" disabled={formData.user_role >= 2} onChange={handleInputChange} className={validationErrors.short_name ? 'invalid' : ''} />
                                                        {validationErrors.short_name && <div className="error error-message">Please Enter up to 25 characters for short company name.</div>}
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label>First Name</label>
                                                        <input type="text" name="fname" defaultValue={formData.fname} placeholder="First Name*" onChange={handleInputChange} className={validationErrors.fname ? 'invalid' : ''} />
                                                        {validationErrors.fname && <div className="error error-message">Please Enter First Name.</div>}
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label>Last Name</label>
                                                        <input type="text" name="lname" defaultValue={formData.lname} placeholder="Last Name*" onChange={handleInputChange} className={validationErrors.lname ? 'invalid' : ''} />
                                                        {validationErrors.lname && <div className="error error-message">Please Enter last name.</div>}
                                                    </div>
                                                    <div className="col-sm-12">
                                                        <label>Email</label>
                                                        <input type="email" name="email" disabled={formData.user_role >= 2} defaultValue={formData.email} placeholder="Email" onChange={handleInputChange} className={validationErrors.email ? 'invalid' : ''} />
                                                        {validationErrors.email && <div className="error error-message">Please enter a valid email address.</div>}
                                                    </div>

                                                    <div className="col-sm-6">
                                                        <label>Office Phone Number</label>
                                                        <input type="number" name="officephone" defaultValue={formData.officephone}
                                                            pattern="[0-9]*" placeholder="Office Phone Number*" onChange={handleInputChange} className={validationErrors.officephone ? 'invalid' : ''} />
                                                        {validationErrors.officephone && <div className="error error-message">Please enter a valid officephone.</div>}
                                                    </div>
                                                    <div className="col-sm-6">
                                                        <label>Mobile Phone Number</label>
                                                        <input type="number" name="mobilephone" defaultValue={formData.mobilephone}
                                                            pattern="[0-9]*" placeholder="Mobile Phone Number*" onChange={handleInputChange} className={validationErrors.mobilephone ? 'invalid' : ''} />
                                                        {validationErrors.mobilephone && <div className="error error-message">Please enter a valid mobilephone.</div>}
                                                    </div>
                                                    {/* {formData.user_role >= '2' && <div className="col-sm-12">
                                                        <p>Access Rights</p>
                                                        <div className="checkboximage">
                                                        {Object.entries(accessRight).map(([key, value]) => (
                                                            <label key={key} htmlFor={key}>
                                                            <input type="checkbox" name={key} id={key} checked={value} onChange={(e) =>
                                                                setAccessRight((prevRights) => ({
                                                                  ...prevRights,
                                                                  [key]: e.target.checked,
                                                                }))}
                                                            />
                                                            {accessRightLabels[key]}
                                                            </label>
                                                        ))}
                                                        </div>
                                                    </div>} */}
                                                </div>
                                            </div>
                                        </div>

                                        {(role == '0' || role == '1' || role == '3' || (role == '2' && hasPermission('createuser'))) && <div className="common-white-shadow-background setting-section">
                                            <div className="innerboxwidth">
                                                <div className="row">
                                                    <h3>Settings</h3>
                                                    <div className="settingbox">
                                                        <label>Minimum Disconnect Option</label>
                                                        <div className="switchbtn">
                                                            <input type="checkbox" id="switch" className="checkbox" disabled={(role > 3)} checked={setting.disconnectSwitch === true} name="disconnectSwitch" onChange={handleSwitchChange} /> <label
                                                                htmlFor="switch" className="toggle">
                                                                <p>
                                                                    {/* OFF ON */}
                                                                </p>
                                                            </label>
                                                        </div>
                                                        <div className="daybox">
                                                            {setting.disconnectSwitch && (


                                                                <label htmlFor="">Days
                                                                    <input type="text" name="disconnectday"
                                                                        placeholder="120" value={setting.disconnectday} onChange={handleDayChange} />
                                                                </label>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {applicationList.length > 0 && applicationList.map((item) => (
                                                        <>
                                                            <div className="settingbox">
                                                                <label>{item.name}</label>
                                                                <div className="switchbtn">
                                                                    <input type="checkbox" id={item.id} className="checkbox" disabled={(role > 3)} checked={formData.pbx_switch.includes(item.id)} onChange={handlePBXSwitchChange} name={item.id} /> <label
                                                                        htmlFor={item.id} className="toggle">
                                                                        <p>

                                                                        </p>
                                                                    </label>
                                                                </div>

                                                            </div>
                                                            {formData.pbx_switch.filter((o) => { return o == item.id }).length > 0 && (<div className="row">
                                                                <div className="col-sm-12">
                                                                    <input type="text" name={item.id} value={formData.pbx_url[item.id]}
                                                                        placeholder={`${item.name} url`} onChange={handleApplicationInputChange} />

                                                                </div>
                                                                {/* <div className="col-sm-6">
                                                            <input type="text" name="pbx_username" defaultValue={formData.pbx_username}
                                                              placeholder="PBX cloud username" onChange={handleInputChange}  />
                                                            
                                                        </div>
                                                        <div className="col-sm-6">
                                                        <input type="password" name="pbx_password" defaultValue={formData.pbx_password}
                                                             placeholder="PBX cloud password" onChange={handleInputChange}  />
                                                            
                                                        </div> */}
                                                            </div>)}
                                                        </>))}

                                                    <div className="settingbox">
                                                        <label>E911</label>
                                                        <div className="switchbtn">
                                                            <input type="checkbox" id="e911_switch" className="checkbox" disabled={(role > 3)} checked={formData.e911_switch === true} name="e911_switch" onChange={handleE911SwitchChange} /> <label
                                                                htmlFor="e911_switch" className="toggle">
                                                                <p>

                                                                </p>
                                                            </label>
                                                        </div>

                                                    </div>
                                                    <div className="settingbox">
                                                        <label>CNAM</label>
                                                        <div className="switchbtn">
                                                            <input type="checkbox" id="cname_switch" className="checkbox" disabled={(role > 3)} checked={formData.cname_switch === true} name="cname_switch" onChange={handleE911SwitchChange} /> <label
                                                                htmlFor="cname_switch" className="toggle">
                                                                <p>

                                                                </p>
                                                            </label>
                                                        </div>

                                                    </div>
                                                    <div className="settingbox">
                                                        <label>Digit Mapping</label>
                                                        <div className="switchbtn">
                                                            <input type="checkbox" id="digit_mapping_switch" className="checkbox" disabled={(role > 3)} checked={formData.digit_mapping_switch === true} name="digit_mapping_switch" onChange={handleE911SwitchChange} /> <label
                                                                htmlFor="digit_mapping_switch" className="toggle">
                                                                <p>

                                                                </p>
                                                            </label>
                                                        </div>

                                                    </div>
                                                    {formData.digit_mapping_switch == true && <div className="settingbox">
                                                        <label>Advance Digit Mapping Option</label>
                                                        <div className="switchbtn">
                                                            <input type="checkbox" id="advance_digit_mapping_switch" className="checkbox" disabled={(role > 3)} checked={formData.advance_digit_mapping_switch === true} name="advance_digit_mapping_switch" onChange={handleE911SwitchChange} /> <label
                                                                htmlFor="advance_digit_mapping_switch" className="toggle">
                                                                <p>

                                                                </p>
                                                            </label>
                                                        </div>

                                                    </div>}
                                                    <div className="settingbox">
                                                        <label>Traffic and Analytics Reporting</label>
                                                        <div className="switchbtn">
                                                            <input type="checkbox" id="report_switch" className="checkbox" disabled={(role > 3)} checked={formData.report_switch === true} name="report_switch" onChange={handleE911SwitchChange} /> <label
                                                                htmlFor="report_switch" className="toggle">
                                                                <p>

                                                                </p>
                                                            </label>
                                                        </div>

                                                    </div>
                                                    <div className="settingbox">
                                                        <label>Inventory Listing</label>
                                                        <div className="switchbtn">
                                                            <input type="checkbox" id="inventory_switch" className="checkbox" disabled={(role > 3)} checked={formData.inventory_switch === true} name="inventory_switch" onChange={handleE911SwitchChange} /> <label
                                                                htmlFor="inventory_switch" className="toggle">
                                                                <p>

                                                                </p>
                                                            </label>
                                                        </div>

                                                    </div>
                                                    <div className="settingbox">
                                                        <label>Mutiple Inventory Edit</label>
                                                        <div className="switchbtn">
                                                            <input type="checkbox" id="multiple_inventory_switch" className="checkbox" disabled={(role > 3)} checked={formData.multiple_inventory_switch === true} name="multiple_inventory_switch" onChange={handleE911SwitchChange} /> <label
                                                                htmlFor="multiple_inventory_switch" className="toggle">
                                                                <p>

                                                                </p>
                                                            </label>
                                                        </div>

                                                    </div>
                                                    <div className="settingbox">
                                                        <label>Use Customer Trunk in NSS</label>
                                                        <div className="switchbtn">
                                                            <input type="checkbox" id="is_nss_trunk_enable" className="checkbox" disabled={(role > 3)} checked={formData.is_nss_trunk_enable === true} name="is_nss_trunk_enable" onChange={handleNSSSwitchChange} /> <label
                                                                htmlFor="is_nss_trunk_enable" className="toggle">
                                                                <p>

                                                                </p>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className="settingbox">
                                                        <label>Enable International Orders</label>
                                                        <div className="switchbtn">
                                                            <input type="checkbox" id="international_order_switch" className="checkbox" disabled={(role > 3)} checked={formData.international_order_switch === true} name="international_order_switch" onChange={handleE911SwitchChange} /> <label
                                                                htmlFor="international_order_switch" className="toggle">
                                                                <p>

                                                                </p>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    {formData.international_order_switch && <div className="settingbox">
                                                        <label>Allowed Ordering Countries</label>
                                                        <div style={{marginBottom : '10px', width: '15%'}}>
                                                        <Select
                                                            classNamePrefix="select"
                                                            name="allow_country_list"
                                                            placeholder="Select Country"   
                                                            value={
                                                                hasUserTouched
                                                                    ? formData.allow_country_list    // ✅ if user has touched, always use this (even if empty)
                                                                    : optionsToSelectCountry(countriesList, formData.country_list)  // ✅ fallback ONLY before first user action
                                                            }
                                                            options={optionsToShowCountry}
                                                            onChange={handleCountryChange} // This handles adding/selecting
                                                            // Prevent clicks inside the select input from removing items
                                                            components={{ MultiValue: CustomMultiValue }} // Use custom component to hide selected tags in input
                                                            isMulti
                                                        />
                                                        </div>
                                                    </div>}
                                                    {/* Display selected countries as tags below the select */}
                                                    {formData.international_order_switch && formData.allow_country_list && formData.allow_country_list.length > 0 && (
                                                        <div style={{ marginTop: '5px', marginBottom: '10px', paddingLeft: '15px', paddingRight: '15px' }}>
                                                            {formData.allow_country_list.map(country => (
                                                                <span key={country.value} style={{
                                                                    display: 'inline-block',
                                                                    backgroundColor: '#e4e4e4',
                                                                    borderRadius: '12px', // Make them rounded tags
                                                                    padding: '4px 10px',
                                                                    margin: '3px', // Add some space between tags
                                                                    fontSize: '0.85em', // Slightly smaller font
                                                                    verticalAlign: 'middle' // Align vertically
                                                                }}>
                                                                    {country.label}
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => handleRemoveCountry(country.value)}
                                                                        style={{
                                                                            marginLeft: '8px', // More space for the 'x'
                                                                            cursor: 'pointer',
                                                                            border: 'none',
                                                                            backgroundColor: 'transparent',
                                                                            color: '#555', // Darker color for 'x'
                                                                            fontWeight: 'bold',
                                                                            padding: '0', // Remove button padding
                                                                            lineHeight: '1' // Adjust line height
                                                                        }}
                                                                    >
                                                                        x
                                                                    </button>
                                                                </span>
                                                            ))}
                                                        </div>
                                                    )}
                                                    <div className="settingbox">
                                                        <label>Call Pass - Branded Calling</label>
                                                        <div className="switchbtn">
                                                            <input type="checkbox" id="call_pass_branded_calling_switch" className="checkbox" disabled={(role > 3)} checked={formData.call_pass_branded_calling_switch === true} name="call_pass_branded_calling_switch" onChange={handleE911SwitchChange} /> <label
                                                                htmlFor="call_pass_branded_calling_switch" className="toggle">
                                                                <p>

                                                                </p>
                                                            </label>
                                                        </div>
                                                    </div>

                                                    {formData.call_pass_branded_calling_switch  && <div className="settingbox">
                                                        <label>Enable Daily Email Call Pass CDRs Schedule</label>
                                                        <div className="switchbtn">
                                                            <input type="checkbox" id="enable_call_pass_cdr_email_schedule" className="checkbox" disabled={(role > 3)} checked={formData.enable_call_pass_cdr_email_schedule === true} name="enable_call_pass_cdr_email_schedule" onChange={handleE911SwitchChange} /> <label
                                                                htmlFor="enable_call_pass_cdr_email_schedule" className="toggle">
                                                                <p>

                                                                </p>
                                                            </label>
                                                        </div>
                                                    </div>}

                                                    {(formData.call_pass_branded_calling_switch && formData.enable_call_pass_cdr_email_schedule) && <div className="settingbox">
                                                        <label>Email</label>
                                                        <div className="col-sm-4">
                                                            <div style={{display: 'flex', gap: '10px', alignItems: 'flex-start'}}>
                                                                <input
                                                                    className='mr-2'
                                                                    style={{flex: '1'}}
                                                                    type="email"
                                                                    name="allowed_call_pass_cdr_emails"
                                                                    placeholder='Email'
                                                                    value={emailInput}
                                                                    onChange={(e) => { setEmailInput(e.target.value); setEmailError(''); }}
                                                                />
                                                                <button
                                                                    type="button"
                                                                    disabled={emailInput.trim() === '' || !validateEmail(emailInput.trim()) || (formData.allowed_call_pass_cdr_emails?.some(item => item.toLowerCase() === emailInput.trim().toLowerCase()))}
                                                                    className={(emailInput.trim() === '' || !validateEmail(emailInput.trim()) || (formData.allowed_call_pass_cdr_emails?.some(item => item.toLowerCase() === emailInput.trim().toLowerCase()))) ? 'disabled-link btn-primary' : 'btn-primary'}
                                                                    onClick={handleAddEmail}
                                                                >
                                                                    Add
                                                                </button>
                                                            </div>
                                                            {emailError && <div className="error error-message" style={{marginTop: '6px'}}>{emailError}</div>}
                                                        </div>
                                                    </div>}

                                                    {(formData.call_pass_branded_calling_switch
                                                        && formData.enable_call_pass_cdr_email_schedule
                                                        && formData.allowed_call_pass_cdr_emails
                                                        && formData.allowed_call_pass_cdr_emails.length > 0
                                                    ) && (
                                                        <div style={{ marginTop: '5px', marginBottom: '10px', paddingLeft: '15px', paddingRight: '15px' }}>
                                                            {formData.allowed_call_pass_cdr_emails.map((email,index) => (
                                                                <span key={index} style={{
                                                                    display: 'inline-block',
                                                                    backgroundColor: '#e4e4e4',
                                                                    borderRadius: '12px', // Make them rounded tags
                                                                    padding: '4px 10px',
                                                                    margin: '3px', // Add some space between tags
                                                                    fontSize: '0.85em', // Slightly smaller font
                                                                    verticalAlign: 'middle' // Align vertically
                                                                }}>
                                                                    {email}
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => handleRemoveEmail(email)}
                                                                        style={{
                                                                            marginLeft: '8px', // More space for the 'x'
                                                                            cursor: 'pointer',
                                                                            border: 'none',
                                                                            backgroundColor: 'transparent',
                                                                            color: '#555', // Darker color for 'x'
                                                                            fontWeight: 'bold',
                                                                            padding: '0', // Remove button padding
                                                                            lineHeight: '1' // Adjust line height
                                                                        }}
                                                                    >
                                                                        x
                                                                    </button>
                                                                </span>
                                                            ))}
                                                        </div>
                                                    )}

                                                    <div className="settingbox">
                                                        <label>Call Pass Display Identities</label>
                                                        <div className="switchbtn">
                                                            <select
                                                                name="call_pass_display_identities_switch"
                                                                value={formData.call_pass_display_identities_switch}
                                                                disabled={(role > 3) || (role <= 2 && !canUpdateCallPassPermissions)}
                                                                onChange={(e) => setFormData({...formData, call_pass_display_identities_switch: parseInt(e.target.value)})}
                                                                className="form-control"
                                                            >
                                                                <option value={0}>No Access</option>
                                                                <option value={1}>View Only</option>
                                                                <option value={2}>Edit Access</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="settingbox timezone">
                                                        <label>Select timeZone</label>
                                                        <div >
                                                            {<select name="timezone" id="timezone" value={formData.timezone} onChange={handleInputChange}>
                                                                <option value="">Timezone</option>
                                                                {timeZones.map((zone) => (
                                                                    <option key={zone.value} value={zone.value}>
                                                                        {zone.value}
                                                                    </option>
                                                                ))}
                                                            </select>}
                                                            {validationErrors.timezone && <div className="error error-message">Please Select TimeZone.</div>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>}
                                        {(role == '0' || role == '1' || role == '3' || (role == '2' && hasPermission('createuser'))) &&
                                            <ApiSecretGeneration baseData={formData} updatedTNSDetail={updatedTNSDetail} />
                                        }
                                        {(role == '0' || role == '1' || role == '3' || (role == '2' && hasPermission('createuser'))) &&
                                            <CompanyCiaDetail baseData={ciaAccessData} token={token} canUpdateCallPassPermissions={canUpdateCallPassPermissions} />
                                        }

                                        {(role == '0' || role == '1' || role == '3' || (role == '2' && hasPermission('createuser'))) && <div className="common-white-shadow-background setting-section">
                                            <div className="row">
                                                <div className="col-5 white-label">
                                                    <h3>Customer Terminating Trunk Assignment (TF DID)</h3>
                                                </div>
                                                <div className="col-7 settingbox">
                                                    <label>Enhance Routing</label>
                                                    <div className="switchbtn">
                                                        <input type="checkbox" id="route_switch" className="checkbox" name="route_switch" checked={formData.route_switch === true} onChange={handleRouteSwitchChange} /> <label
                                                            htmlFor="route_switch" className="toggle">
                                                            <p>

                                                            </p>
                                                        </label>
                                                    </div>

                                                </div>
                                                <CreateInputForm addToList={addToValueList} trunkDisabled={trunkDisabled} />
                                                <DisplayTable carrierTrunk={carrierTrunk} values={valueList} currentTrunk={trunkId} removeFromList={removeFromValueList} handleTrunkInputChange={handleTrunkInputChange} handleTrunkAliasInputChange={handleTrunkAliasInputChange} handleCheckboxChange={handleCheckboxChange} handleBandwidthDidCheckboxChange={handleBandwidthDidCheckboxChange} handleBandwidthTollFreeCheckboxChange={handleBandwidthTollFreeCheckboxChange} handleDidAccessCheckboxChange={handleDidAccessCheckboxChange} handleTollFreeAccessCheckboxChange={handleTollFreeAccessCheckboxChange} handleInternationalOrderAccessCheckboxChange={handleInternationalOrderAccessCheckboxChange} trunkData={trunkData} bandwdithDidData={bandwdithDidData} bandwdithTollFreeData={bandwdithTollFreeData} selectDidAccessData={selectDidAccessData} selectTollFreeAccessData={selectTollFreeAccessData} selectInternationalOrderAccessData={selectInternationalOrderAccessData} trunkAliasInputData={trunkAliasInputData} />
                                                {/* {validationErrors.tid && <div className="error error-message">Please Enter valid TID.</div>} */}
                                            </div>
                                        </div>}

                                        {(role == '0' || role == '1' || role == '3' || (role == '2' && hasPermission('createuser'))) && <div className="common-white-shadow-background setting-section">
                                            <div className="row">

                                                <div className="col-5 white-label">
                                                    <h3>Customer Originating Trunk Assignment (otg - LD)</h3>
                                                </div>
                                                <div className="col-7 settingbox">


                                                </div>
                                                <CreateOutboundInputForm addToList={addToOutboundValueList} outBoundTrunkDisabled={outBoundTrunkDisabled} />
                                                <DisplayOutboundTable carrierTrunk={carrierTrunk} values={outboundValueList} currentTrunk={outboundTrunkId} removeFromList={removeFromOutboundValueList} handleOutboundTrunkInputChange={handleOutboundTrunkInputChange} handleOutboundCheckboxChange={handleOutboundCheckboxChange} outboundTrunkData={outboundTrunkData} />
                                                {/* {validationErrors.tid && <div className="error error-message">Please Enter valid TID.</div>} */}
                                            </div>
                                        </div>}
                                        <div className="common-white-shadow-background setting-section">
                                            <div className="row">
                                                <div className="col-5 white-label">
                                                    <h3>Sansays Priority (For reporting)</h3>
                                                </div>
                                                <div className="fullwidth-table track-table-body trunk-table staff-listing-admin-table-body">
                                                    <table>
                                                        {sansayList.map((item, index) => (
                                                            <tr key={index}>
                                                                <td>{item.name}</td>
                                                                <td><input type="checkbox" checked={checkedItems.length > 0 && checkedItems.includes(item.name)} onChange={(e) => handleSansayPriorityCheckbox(item.name, e.target.checked)} /></td>
                                                            </tr>
                                                        ))}
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <input type="submit" value="Update Customer" className={buttonDisabled ? 'yellow-button disabled-link' : 'yellow-button'} />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>

            {/* NSS Trunk Removal Modal */}
            <NssTrunkRemovalModal
                isOpen={nssTrunkRemovalModal.isOpen}
                onClose={handleNssRemovalModalClose}
                trunkData={nssTrunkRemovalModal.trunkData}
                onConfirmRemoval={handleNssRemovalConfirm}
                onSubmitExplanation={handleNssRemovalExplanation}
                isLoading={nssTrunkRemovalModal.isLoading}
            />
        </div>
    )
}
export default EditUser
